import React from 'react';
import { Center, VStack, HStack } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import { Button, Modal } from '~/shared/Theme';

type DeleteCardsModalProps = {
    onCancel: () => void;
    onSubmit: () => void;
    isLoading?: boolean;
};

const DeleteCardsModal = ({
    onCancel,
    onSubmit,
    isLoading
}: DeleteCardsModalProps) => {

    return (
        <Center>
            <Modal isOpen overflowY={'auto'}>
                <Modal.Header>
                    <H3 text={'giftCard.deleteCardsModal.title'} />
                </Modal.Header>
                <Modal.Body>
                    <VStack space={4} textAlign={'center'}>
                        <Caption text={'giftCard.deleteCardsModal.description'} />
                        <Caption text={'giftCard.deleteCardsModal.disclaimer'} />
                    </VStack>
                </Modal.Body>
                <Modal.Footer>
                    <HStack space={4}>
                        <Button
                            text={'giftCard.deleteCardsModal.backButton'}
                            variant={'neutral'}
                            onPress={() => onCancel()}
                            disabled={isLoading}
                        />
                        <Button
                            text={'giftCard.deleteCardsModal.confirmButton'}
                            variant={'danger'}
                            onPress={() => onSubmit()}
                            disabled={isLoading}
                        />
                    </HStack>
                </Modal.Footer>
            </Modal>
        </Center>
    );
};

export default DeleteCardsModal;
